import { useState } from 'react';
import { api } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';

const fmt = (n) => `$${Number(n || 0).toLocaleString('es-CO')}`;

export const RateImport = ({ onApplied }) => {
  const [file, setFile] = useState(null);
  const [res, setRes] = useState(null);
  const [busy, setBusy] = useState(false);

  const send = async (mode) => {
    if (!file) return;
    const fd = new FormData();
    fd.append('file', file);
    fd.append('mode', mode);
    if (mode === 'apply') fd.append('preview_hash', res.preview_hash);
    setBusy(true);
    try {
      const { data } = await api.post('/admin/logistics/standard-rates/import', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      setRes(data);
      if (mode === 'apply') { toast.success(`Tarifas reemplazadas (${data.rows.length})`); onApplied?.(); }
    } catch (e) { toast.error(e.response?.data?.detail?.message || e.response?.data?.detail || 'No se pudo procesar el archivo'); }
    finally { setBusy(false); }
  };
  const template = async () => {
    const { data } = await api.get('/admin/logistics/standard-rates/template', { responseType: 'blob' });
    const a = document.createElement('a'); a.href = URL.createObjectURL(data); a.download = 'plantilla_tarifas_envio.csv'; a.click();
  };
  const d = res?.diff;
  return (
    <div className="mb-4 border border-dashed border-slate-300 p-3" data-testid="rate-import">
      <div className="text-xs font-bold uppercase tracking-[0.18em] text-slate-500">Carga masiva (CSV o Excel)</div>
      <p className="mt-1 text-xs text-slate-500">Columnas: departamento, ciudad (opcional), tarifa, dias_min, dias_max. Primero se previsualiza; nada se guarda hasta confirmar.</p>
      <div className="mt-2 flex flex-wrap items-center gap-2">
        <input type="file" accept=".csv,.xlsx" onChange={(e) => { setFile(e.target.files?.[0] || null); setRes(null); }} className="text-sm" data-testid="rate-import-file" />
        <Button size="sm" variant="outline" className="rounded-none" onClick={template} data-testid="rate-import-template">Descargar plantilla</Button>
        <Button size="sm" className="rounded-none bg-slate-900" disabled={!file || busy} onClick={() => send('preview')} data-testid="rate-import-preview">Previsualizar</Button>
      </div>
      {res && (
        <div className="mt-3 text-xs" data-testid="rate-import-result">
          <p>Filas válidas {res.rows.length} · Errores <b className={res.errors.length ? 'text-rose-700' : ''}>{res.errors.length}</b> · Nuevas {d.added.length} · Cambian {d.changed.length} · Se eliminan {d.removed.length} · Sin cambio {d.unchanged}</p>
          {res.errors.slice(0, 10).map((e, i) => <p key={i} className="text-rose-700">Fila {e.row}: {e.message}</p>)}
          {d.changed.slice(0, 5).map((c, i) => <p key={i} className="text-slate-600">{c.after.department}{c.after.city ? ` / ${c.after.city}` : ''}: {fmt(c.before.rate)} → {fmt(c.after.rate)}</p>)}
          {!res.applied && !res.errors.length && res.rows.length > 0 && (
            <Button size="sm" className="mt-2 rounded-none bg-orange-600 hover:bg-orange-700" disabled={busy}
              onClick={() => window.confirm(`Se reemplazarán las ${res.current_count} tarifas actuales por ${res.rows.length}. ¿Confirmas?`) && send('apply')}
              data-testid="rate-import-apply">Aplicar tarifas</Button>
          )}
        </div>
      )}
    </div>
  );
};
